import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { UserService } from '@core/services/user.service';
import { Article } from '@modules/articles/models/article';

import { ContentBlockedComponent } from '@shared/components/content-blocked/content-blocked.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { TrackingService } from '@core/services/tracking.service';
import { extractNamesArray } from '@core/utils/helpers';

@Component({
	selector: 'kwo-article-item',
	templateUrl: './article-item.component.html',
	styleUrls: ['./article-item.component.scss'],
	standalone: true,
	imports: [CommonModule, SafeHtmlPipe],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticleItemComponent implements OnInit {

	@Input() article: Article;

	router = inject(Router);
	dialog = inject(MatDialog);
	translate = inject(TranslateService);
	userService = inject(UserService);
	isLoggedIn: boolean = false;

	ngOnInit(): void {

		this.isLoggedIn = this.userService.getUser() !== null;
	}

	goToArticle(slug: string) {
		if (!this.isLoggedIn) {

			this.translate.get('app.content_blocked.article').subscribe((text: string) => {

				this.dialog.open(ContentBlockedComponent, {
					width: '400px',
					data: { message: text },
					scrollStrategy: new NoopScrollStrategy()
				});
			});

			return;
		}

		this.router.navigate(['artikelen', slug]);
	}
}